export const BUILDER_BLOCK_SKILLS_SIDEBAR_CLOSE = 'builder-block-skills-sidebar-close';
export const BUILDER_BLOCK_SKILLS_COPIED = 'builder-block-skills-copied';
